export default __webpack_public_path__ + "static/header.wedl-592dd01edda103253efbcbf4c4b4b90e.jpg";